export default __webpack_public_path__ + "static/media/96.25774ebc.png";